module.exports = __webpack_public_path__ + "static/media/Lateral_Normal_Z1.9233d57c.png";